<script>
import AdminBatchChooser from '@/layerAdmin/components/AdminBatchChooser.vue';
import LayerBatchManage from '@/layerAdmin/components/LayerBatchManage.vue';

export default {
  components: {
    AdminBatchChooser,
    LayerBatchManage,
  },

  data: () => ({
    batch: undefined,
    reloadBatchChooser: 0,
  }),

  computed: {
    batchName: {
      get() { return this.$route.query.selected_batch || '' },
      set(value) { this.$router.push({ query: { selected_batch: value } }); },
    },
  },
}
</script>

<template>
  <div>

    <b-card class="mb-2">

      <div class="h5 m-0"> Manage Batch </div>

      <admin-batch-chooser
        :key="reloadBatchChooser"
        v-model="batchName"
        :auto-focus="true"
        class="mt-3"
        required></admin-batch-chooser>

    </b-card>

    <api-loader
      v-if="batchName"
      :key="batchName"
      method="get"
      :url="`v1/layeradmin/batches/${encodeURIComponent(batchName)}`"
      @loaded="batch=$event" />

    <layer-batch-manage
      v-if="batch"
      :batch="batch"
      @update="batch = $event"
      @cancel="batch = undefined; batchName = undefined;"
      @delete="batch = undefined; batchName = undefined; reloadBatchChooser++;" />

  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/ManageLayerBatches.vue